import { any, compose, equals, hasPath, prop, propOr } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';
import { createSelector } from 'reselect';

import { EMPTY_VALUES } from 'constants/general';

import constants from './constants';

const name = constants.NAME;

const getUserContext = (state) => state[name];

export const getContextUser = compose(prop('contextUser'), getUserContext);

export const getPreviousContextUser = compose(prop('previousContextUser'), getUserContext);

export const getIsSubordinate = createSelector(getContextUser, (contextUser) => !isNilOrEmpty(contextUser));

export const getContextuserPermissions = createSelector(getUserContext, propOr(EMPTY_VALUES.OBJECT, 'permissions'));
export const hasContextPermissionById = createSelector(
	getContextuserPermissions,
	(state, permissionId) => permissionId,
	(contextUserPermissions, permissionId) => {
		return hasPath([permissionId[0].id], contextUserPermissions);
	},
);

export const getContextUserAdditionalInfo = createSelector(
	getUserContext,
	propOr(EMPTY_VALUES.OBJECT, 'additionalInfo'),
);

export const getContextUserRoleMap = createSelector(
	getContextUserAdditionalInfo,
	propOr(EMPTY_VALUES.ARRAY, 'roleStructureMap'),
);

export const getContextUserHasRole = createSelector(
	getContextUserRoleMap,
	(state, role) => role,
	(contextUserRoleMap, role) => {
		const rolesOnly = contextUserRoleMap.map((item) => item.role);
		return any(equals(role))(rolesOnly);
	},
);
